import { dateOf } from '../../nucleus/format';

// PEOPLE — the store behind the People page (parity with nucleus.oS
// People.swift PeopleStore): your relationships when you are in your own
// space, the group's members when you are in a group. One row per follow, read
// from whichever side is the other person.

export function nameOf(u = {}) {
    const full = [u.first_name, u.last_name].filter(Boolean).join(' ');
    return full || u.username || 'Someone';
}

// WHETHER ONE DIRECTION OF SHARING IS LIVE (prod PeopleTab sharingState). A
// friendship and the sharing under it come apart: the follow stays accepted
// while the profile beneath it expires. `is_active` stays true through expiry,
// so expiry is tested on its own. An ENDING outranks a pause: paused past its end
// date is expired, as the server counts it (friendship.side_end) and has told the
// other person — Resume would leave it expired, so it reads ended, and is renewed.
export function sharingState(ep, now = new Date()) {
    if (!ep) return { state: 'none', label: 'Nothing shared' };
    if (ep.revoked_at) return { state: 'revoked', label: 'Revoked' };
    const when = ep.expires_at ? new Date(ep.expires_at) : null;
    if (when && when <= now) return { state: 'expired', label: `Expired ${dateOf(when)}` };
    if (ep.is_active === false) return { state: 'paused', label: 'Paused' };
    return when ? { state: 'live', label: `Until ${dateOf(when)}` } : { state: 'live', label: 'No expiry' };
}

export const rank = (role) => ({ owner: 0, admin: 1 }[role] ?? 2);

export const EMPTY = {
    group: false, members: [], incoming: [], friends: [], sent: [], following: [], followers: [],
    invitations: [], groups: [], suggested: [], followingIds: [], publicOn: null,
};

// Group members, owners and admins first.
export function memberOf(m) {
    return {
        id: String(m.user_id || m.user?.id || m.id),
        // their name when the members list carries it, else their username
        name: nameOf({ first_name: m.first_name ?? m.user?.first_name, last_name: m.last_name ?? m.user?.last_name, username: m.user?.username || m.username }),
        username: m.user?.username || m.username || null,
        role: m.role || 'member',
        realm: m.privacy_realm_name || null,
        realmId: m.privacy_realm_id || null,
        joined: m.joined_at || null,
        // the photo on the identity they present to the group (null without one)
        avatar: m.avatar_url || m.user?.avatar_url || null,
        // the membership's two contracts: what they share with the group (realm
        // names; empty = nothing) and what the group lets them do
        shareEpId: m.share_ep_id ? String(m.share_ep_id) : null,
        shares: m.share_realm_names || [],
        // whether they share anything, and how it stands when the roster says:
        // another member's realm names are theirs and are never shown
        sharing: typeof m.sharing === 'boolean' ? m.sharing
            : Array.isArray(m.share_realm_names) ? m.share_realm_names.length > 0 : !!m.share_ep_id,
        shareState: m.share_state || null,
        accessEpId: m.access_ep_id ? String(m.access_ep_id) : null,
        // how what the group lets them do stands: active, paused, expired, revoked (null: unknown)
        accessState: m.access_state || null,
    };
}
export const sortMembers = (list) => list.sort((a, b) => rank(a.role) - rank(b.role) || a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
